import { render, staticRenderFns } from "./frontdesk.vue?vue&type=template&id=fbceebe6&scoped=true"
import script from "./frontdesk.vue?vue&type=script&lang=js"
export * from "./frontdesk.vue?vue&type=script&lang=js"
import style0 from "./frontdesk.vue?vue&type=style&index=0&id=fbceebe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbceebe6",
  null
  
)

export default component.exports